import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as Money } from './MoneyFilled.svg';
import { IconContainer } from './styles';

const MoneyFilled = ({ isActive }) => (
  <IconContainer isActive={isActive.toString()}>
    <Money />
  </IconContainer>
);

MoneyFilled.propTypes = {
  isActive: PropTypes.bool,
};

MoneyFilled.defaultProps = {
  isActive: false,
};

export default MoneyFilled;
